var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"ds-select",class:{ 'ds-select--invalid': _vm.invalid },attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((_vm.options),function(o){return _c('option',{key:o.value,domProps:{"value":o.value}},[_vm._v(_vm._s(o.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }